module.exports = __webpack_public_path__ + "static/original-plus-cover-a9272b53c6ae7a4ea31326ba2ad01d48.mp4";